import { render } from "./add_retailer_model.vue?vue&type=template&id=88ec25ae"
import script from "./add_retailer_model.vue?vue&type=script&lang=js"
export * from "./add_retailer_model.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__